import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=91f5d85e&scoped=true&lang=pug&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=91f5d85e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f5d85e",
  null
  
)

component.options.__file = "MessageList.vue"
export default component.exports